import Core from '../core';
import { AxiosError } from 'axios';

async function clockOut(empId: number, companyId: number) {
  const api = Core.getInstance().api();

  const data = await api.post(
    `/clock_out?emp_id=${empId}&company_id=${companyId}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function check_out(
  checkout_time: any,
  empId: number,
  lat: any,
  lng: any,
  companyId: any,
) {
  const api = Core.getInstance().api();

  const data = await api.post(
    `/v2/attendance/checkout?emp_id=${empId}&lat=${lat}&lng=${lng}&company_id=${companyId}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

export const clockOutService = {
  clockOut,
  check_out,
};
